import React from 'react';

function DotsCorner({ color = 'currentColor', ...props }) {
  return (
    <svg
      fill={color}
      viewBox="0 0 36 36"
      version="1.1"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <title>drag-handle-corner-line</title>{' '}
        <circle
          cx="12"
          cy="24"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-1"
        ></circle>
        <circle
          cx="18"
          cy="24"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-2"
        ></circle>
        <circle
          cx="18"
          cy="18"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-3"
        ></circle>
        <circle
          cx="24"
          cy="12"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-4"
        ></circle>
        <circle
          cx="24"
          cy="24"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-5"
        ></circle>
        <circle
          cx="24"
          cy="18"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-6"
        ></circle>{' '}
        <rect x="0" y="0" width="36" height="36" fill-opacity="0"></rect>{' '}
      </g>
    </svg>
  );
}

export default DotsCorner;
